import { Button, Card, TextField } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import useClinicMrn from "./useClinicMrn";
import { onClinicMrnChange } from "app/store/transmission/slice/transmissionSlice";
import { CLINIC_NAMES, CLINIC_ROLES } from "static/constants";

const ClinicMrn = ({ data, role, clinicName }) => {
  const {
    dispatch,
    clinicMrn,
    clinicMrnTouched,
    clinicMrnSubmitting,
    onSaveClinicMrn,
  } = useClinicMrn(data);
  const { isArchiveReport } = useSelector((state) => state.archiveReport);

  return (
    [CLINIC_NAMES.MIAMI].includes(clinicName) &&
    CLINIC_ROLES.includes(role) && (
      <Card className="view-pdf__mrn">
        <TextField
          id="mrn"
          label="MRN"
          margin="none"
          variant="outlined"
          onChange={(e) =>
            dispatch(
              onClinicMrnChange({
                mrn: e.target.value,
                mrnTouched: true,
              })
            )
          }
          value={clinicMrn}
          fullWidth
          inputProps={{ maxLength: 30 }}
          disabled={
            clinicMrnSubmitting ||
            data?.locked ||
            data?.legacy ||
            isArchiveReport
          }
        />
        <Button
          onClick={onSaveClinicMrn}
          className="view-pdf__button"
          variant="contained"
          color="secondary"
          disabled={
            clinicMrnSubmitting ||
            !clinicMrnTouched ||
            data?.locked ||
            data?.legacy ||
            isArchiveReport
          }
        >
          {clinicMrnSubmitting ? "Updating..." : "Update"}
        </Button>
      </Card>
    )
  );
};

export default ClinicMrn;
